import { Bill, BillStatus } from '../../../../generated'
import { HourlyCase } from '../../../interfaceTypes/forms'

export interface FundRequestsFilters {
  matter?: HourlyCase
  status?: BillStatus
  searchTerm?: string
}

export interface FundRequestsState {
  fundRequests: Bill[]
  filters: FundRequestsFilters
  loading: boolean
}

export const fundRequestsInitialState: FundRequestsState = {
  fundRequests: [],
  filters: {
    searchTerm: ''
  },
  loading: false
}

export enum FundRequestsActionType {
  SET_FUND_REQUESTS = 'setFundRequests',
  SET_FILTERS = 'setFilters',
  SET_LOADING = 'setLoading',
  RESET_FILTERS = 'resetFilters'
}

export type FundRequestsAction =
  | { type: FundRequestsActionType.SET_FUND_REQUESTS; fundRequests: Bill[] }
  | { type: FundRequestsActionType.SET_FILTERS; filters: FundRequestsFilters }
  | { type: FundRequestsActionType.SET_LOADING; loading: boolean }
  | { type: FundRequestsActionType.RESET_FILTERS }

export const fundRequestsReducer = (state: FundRequestsState, action: FundRequestsAction): FundRequestsState => {
  switch (action.type) {
    case FundRequestsActionType.SET_FUND_REQUESTS:
      return {
        ...state,
        fundRequests: action.fundRequests
      }

    case FundRequestsActionType.SET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.filters }
      }

    case FundRequestsActionType.SET_LOADING:
      return {
        ...state,
        loading: action.loading
      }

    case FundRequestsActionType.RESET_FILTERS:
      return {
        ...state,
        filters: {}
      }

    default:
      return state
  }
}
